// TKP-147 / tasarım s.35 md.5,7 (s.20 md.4): ekran kalktı; eski adres panelin açılış sayfasına yönlenir. Backend, veri ve raporlar yerinde.
export const organization = {
  routes: [
    { path: "/organization/question-set-survey", redirect: "/organization" },
  ],
};
export const gdpr = {
  routes: [
    { path: "/gdpr/question-set-survey", redirect: "/gdpr/entities" },
  ],
};
export const kvkk = {
  routes: [
    { path: "/kvkk/question-set-survey", redirect: "/kvkk/entities" },
  ],
};
export const ddo = {
  routes: [
    { path: "/ddo/question-set-survey", redirect: "/ddo/roadmap" },
  ],
};
export const bgys = {
  routes: [
    { path: "/bgys/question-set-survey", redirect: "/bgys/roadmap" },
  ],
};
